import PropTypes from "prop-types";

import { IconButton, Paragraph2, SVG } from "../../components";
import { SelectedItemWrapper } from "./styled";

const SelectedItem = ({ value, onDelete, disabled }) => {
  return (
    <SelectedItemWrapper as="li" disabled={disabled}>
      <Paragraph2>{value}</Paragraph2>
      {onDelete && (
        <IconButton onClick={onDelete}>
          <SVG.CloseIcon />
        </IconButton>
      )}
    </SelectedItemWrapper>
  );
};

SelectedItem.propTypes = {
  value: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
  disabled: PropTypes.bool
};

export default SelectedItem;
